exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#profile-tabs .vs-tabs--content{\n  padding:0\n}", ""]);

// exports
